// ============================================================================
// AHO-CORASICK - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'aho-corasick',
  name: 'Aho-Corasick',
  category: 'Strings',
  complexity: {
    time: 'O(N + M + Z)',
    space: 'O(M * K)'
  },
  description: 'A string searching algorithm that finds all occurrences of multiple patterns in a text in linear time. It builds a finite state machine (trie with failure links) to process the text in a single pass.'
};
